import { useState } from "react";
import { DialogContainer } from "./DialogContainer";

interface DialogManagerProps {
  sampleData: any[];
  setSampleData: (data: any[]) => void;
  isCredit: boolean;
}

export const DialogManager = ({
  sampleData,
  setSampleData,
  isCredit,
}: DialogManagerProps) => {
  const [dialogType, setDialogType] = useState<"sale" | "restock" | "loss" | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  return dialogType && selectedItem ? (
    <DialogContainer
      type={dialogType}
      sampleData={sampleData}
      setSampleData={setSampleData}
      isCredit={isCredit}
      selectedItem={selectedItem}
      onClose={() => {
        setDialogType(null);
        setSelectedItem(null);
      }}
    />
  ) : null;
};